const translation = {
  daysInWeek: {
    Tue: '火曜日',
    Sat: '土曜日',
    Mon: '月曜日',
    Thu: '木曜日',
    Fri: '金曜日',
    Wed: '水曜日',
    Sun: '日曜日',
  },
  months: {
    November: '11 月',
    December: '12 月',
    March: '3 月',
    September: '9 月',
    July: '7 月',
    April: '4 月',
    February: '2 月',
    June: '6 月',
    January: '1 月',
    May: '5 月',
    August: '8 月',
    October: '10 月',
  },
  operation: {
    now: '今',
    cancel: 'キャンセル',
    ok: 'はい',
    pickDate: '日付を選択',
  },
  title: {
    pickTime: 'ピックタイム',
  },
  defaultPlaceholder: '時間を選んでください...',
}

export default translation
